import { render, staticRenderFns } from "./AttendanceReasons.vue?vue&type=template&id=40008017&scoped=true"
import script from "./AttendanceReasons.vue?vue&type=script&lang=js"
export * from "./AttendanceReasons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40008017",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout})
